import { createContext, useContext, useEffect, useState } from "react";
import { memberApi } from "@/lib/api";

const MemberAuthContext = createContext(null);

export const MemberAuthProvider = ({ children }) => {
  const [member, setMember] = useState(null); // null = checking, false = anon, obj = member
  const [token, setToken] = useState(localStorage.getItem("fhp_member_token"));

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (!token) {
        if (active) setMember(false);
        return;
      }
      try {
        const { data } = await memberApi.get("/community/me");
        if (active) setMember(data);
      } catch {
        localStorage.removeItem("fhp_member_token");
        if (active) {
          setToken(null);
          setMember(false);
        }
      }
    };
    check();
    return () => {
      active = false;
    };
  }, [token]);

  const persist = (data) => {
    localStorage.setItem("fhp_member_token", data.access_token);
    setToken(data.access_token);
    setMember(data.member);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await memberApi.post("/community/login", { email, password });
    return persist(data);
  };

  const register = async (name, email, password) => {
    const { data } = await memberApi.post("/community/register", { name, email, password });
    return persist(data);
  };

  const logout = () => {
    localStorage.removeItem("fhp_member_token");
    setToken(null);
    setMember(false);
  };

  return (
    <MemberAuthContext.Provider value={{ member, login, register, logout }}>
      {children}
    </MemberAuthContext.Provider>
  );
};

export const useMemberAuth = () => useContext(MemberAuthContext);
